import { useWizardContext } from "./hooks";
import { StepButton } from "./step-button";

export const WizardStepper = () => {
  const { steps, active, disabled, activeStepIndex, onChange } =
    useWizardContext();

  return (
    <div className="flex flex-col items-stretch gap-2 text-sm text-v2-primary">
      {steps.map((step, index) => {
        return (
          <StepButton
            key={step.value}
            index={index}
            disabled={disabled}
            active={step.value === active}
            complete={index < activeStepIndex}
            icon={step.icon}
            label={step.label}
            onClick={() => onChange(step.value)}
          />
        );
      })}
    </div>
  );
};
